import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ModalEnums } from '@pkg-enums/modal';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private _subject = new Subject<any>();
  modals: { subject: Subject<any>; params: ModalEnums }[] = [];
  private _idx = 1;

  constructor() {}

  getObservable(): Observable<any> {
    return this._subject.asObservable();
  }

  createModal(object: ModalEnums) {
    const params = {
      id: this._idx++,
      style: object?.style,
      presentation: object?.presentation,
      title: object?.title,
      data: object?.data,
      component: object?.component,
      forceClose: object?.forceClose,
      hideCloseBt: object?.hideCloseBt,
      callback: object?.callback,
      callbackClose: object?.callbackClose,
      callbackDelete: object?.callbackDelete,
      onBeforeClose: object?.onBeforeClose,
      onClose: object?.onClose,
      options: object?.options,
      hasStickyFooter: object?.hasStickyFooter !== undefined ? object?.hasStickyFooter : true,
      isCentered: object?.isCentered !== undefined ? object?.isCentered : false,
      contentMaxWidth: object?.contentMaxWidth
    };
    this._subject.next(params);
    this.modals.push({ subject: this._subject, params });
  }

  deleteModals() {
    const ele = { destroy: true };
    for (const obsItem in this.modals) {
      this.modals[obsItem]?.subject.next(ele);
    }
  }
}
